import { render, staticRenderFns } from "./StokAktarSecButon.vue?vue&type=template&id=2dc7cb70"
import script from "./StokAktarSecButon.vue?vue&type=script&lang=js"
export * from "./StokAktarSecButon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports